import { render, staticRenderFns } from "./OrderItemsPanel.vue?vue&type=template&id=48b67dd2&scoped=true&"
import script from "./OrderItemsPanel.vue?vue&type=script&lang=js&"
export * from "./OrderItemsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b67dd2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VDivider,VRow,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b67dd2')) {
      api.createRecord('48b67dd2', component.options)
    } else {
      api.reload('48b67dd2', component.options)
    }
    module.hot.accept("./OrderItemsPanel.vue?vue&type=template&id=48b67dd2&scoped=true&", function () {
      api.rerender('48b67dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/components/scheduled/OrderItemsPanel.vue"
export default component.exports